import React from 'react';
import styled from 'styled-components';
import { CloudDownloadOutlined } from '@ant-design/icons';




import {
    Accordion,
    AccordionItem,
    AccordionItemHeading,
    AccordionItemButton,
    AccordionItemPanel,
} from 'react-accessible-accordion';


import '../assets/accordion.css';

import Seperate from '../components/seperateTool.js';
import Rotate from '../components/rotateTool.js';
import Spin from '../components/spinTool.js';
import PerpendicularShift from '../components/perpendicularShiftTool.js';
import Expand from '../components/expandTool.js';
import Reference from '../components/reference.js';
import Detach from '../components/detachTool.js';


function ManipulationTool() {

	const clipBoardText = "Xian, Y., Xie, Y., Silva, S. M., Karki, C. B., Qiu, W., & Li, L. (2021). StructureMan: A Structure Manipulation Tool to Study Large Scale Biomolecular Interactions. Frontiers in molecular biosciences, 7, 476.";

  return (
    <div class="inner-section">
    <div class="container">
        <h3 class="header-title">Structure Manipulation Tools</h3>
				<H5>The Structure Manipulation Tools are designed to manipulate the structures in biomolecule-biomolecule interactions. Please select one operation below to start:</H5>
				<Accordion>
            <AccordionItem>
                <AccordionItemHeading>
                    <AccordionItemButton>
                        Separate
                    </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <Seperate/>
                </AccordionItemPanel>
            </AccordionItem>
            <AccordionItem>
                <AccordionItemHeading>
                    <AccordionItemButton>
                      Rotate
                    </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <Rotate/>
                </AccordionItemPanel>
            </AccordionItem>
						<AccordionItem>
                <AccordionItemHeading>
                    <AccordionItemButton>
                      Spin
                    </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                    <Spin/>
                </AccordionItemPanel>
            </AccordionItem>

						<AccordionItem>
                <AccordionItemHeading>
                    <AccordionItemButton>
                      Perpendicular Shift
                    </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                    <PerpendicularShift/>
                </AccordionItemPanel>
            </AccordionItem>

						<AccordionItem>
                <AccordionItemHeading>
                    <AccordionItemButton>
                      Expand
                    </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                    <Expand/>
                </AccordionItemPanel>
            </AccordionItem>

						<AccordionItem>
								<AccordionItemHeading>
										<AccordionItemButton>
											Detach
										</AccordionItemButton>
								</AccordionItemHeading>
								<AccordionItemPanel>
										<Detach/>
								</AccordionItemPanel>
						</AccordionItem>

        </Accordion>

				<RefContactContainer>
					<ReferenceContainer>
						<h6>We humbly ask to cite this reference if your results from this web server are used in publications.</h6>
						<Reference title="Manipulation Tool" clipBoardText={clipBoardText} publicationLink="https://www.frontiersin.org/articles/10.3389/fmolb.2020.627087/full"/>
					</ReferenceContainer>
					<ContactContainer>
						<Contact> <b>Contact:</b> lli5@utep.edu</Contact>
						<A href="/software">
							<CloudDownloadOutlined style={{ fontSize: '33px' }} />
						  	Download Tools
						</A>
					</ContactContainer>

				</RefContactContainer>


		 </div>


    </div>




  );
}






const Contact = styled.p`
    margin-top: 22px;
`;

const RefContactContainer = styled.div`
	display:flex;
	flex-direction: column;
  justify-content: space-between;
  align-items: center;
	margin-top:45px;
`;

const ContactContainer = styled.div`
	display: flex;
	flex-direction:row;
	font-family:"Fira Sans";
	justify-content:space-between;
	width: 100%;
	align-items:center;
`;

const ReferenceContainer = styled.div`
	display:flex;
	flex-direction:column;
`;

const A = styled.a`
	display:flex;
  flex-direction: column;
	margin-right: 15px;
`;

const H5 = styled.h5`
	margin-bottom:40px;
`;


export default ManipulationTool;



// WEBPACK FOOTER //
// ./src/pages/manipulationTool.js